document.addEventListener("DOMContentLoaded", () => {
  const addItemBtn = document.getElementById("sales-add-item");
  const itemsTable = document.querySelector("#sales-items-table-body");
  const orderTotalDisplay = document.getElementById("sales-order-total");
  const itemTemplate = document.getElementById("sales-item-template");

  function recalcRowTotal(row) {
    const unitPrice = parseFloat(row.querySelector(".sales-unit-price")?.value) || 0;
    const qty = parseFloat(row.querySelector(".sales-qty")?.value) || 0;
    const rowTotalField = row.querySelector(".sales-row-total");
    const total = unitPrice * qty;
    if (rowTotalField) rowTotalField.value = total.toFixed(2);
  }

  function recalcOrderTotal() {
    let sum = 0;
    itemsTable.querySelectorAll(".sales-item-row").forEach(row => {
      const destroyFlag = row.querySelector(".sales-destroy-flag");
      if (!destroyFlag || destroyFlag.value !== "1") {
        const rowTotalField = row.querySelector(".sales-row-total");
        sum += parseFloat(rowTotalField?.value) || 0;
      }
    });
    if (orderTotalDisplay) orderTotalDisplay.textContent = sum.toFixed(2);
  }

  if (addItemBtn) {
    addItemBtn.addEventListener("click", () => {
      if (!itemTemplate) return;

      const newRowHtml = itemTemplate.innerHTML;
      const uniqueIndex = new Date().getTime();
      const rowHtml = newRowHtml.replace(/NEW_RECORD/g, uniqueIndex);

      const tempDiv = document.createElement("tbody");
      tempDiv.innerHTML = rowHtml.trim();
      const newRow = tempDiv.firstElementChild;

      newRow.querySelectorAll("input, select").forEach(input => {
        if (input.type === "text" || input.type === "number") input.value = "";
        if (input.classList.contains("sales-destroy-flag")) input.value = "0";
      });

      itemsTable.appendChild(newRow);
    });
  }

  if (itemsTable) {
    itemsTable.addEventListener("click", (e) => {
      const removeLink = e.target.closest(".sales-remove-item");
      if (removeLink) {
        const row = removeLink.closest("tr");
        const destroyFlag = row.querySelector(".sales-destroy-flag");
        if (destroyFlag) {
          destroyFlag.value = "1";
          row.style.display = "none";
        } else {
          row.remove();
        }
        recalcOrderTotal();
      }
    });

    itemsTable.addEventListener("input", (e) => {
      const row = e.target.closest("tr");
      if (row && (e.target.classList.contains("sales-unit-price") || e.target.classList.contains("sales-qty"))) {
        recalcRowTotal(row);
        recalcOrderTotal();
      }
    });

    // NEW PART: auto-fill unit_sale_price when product is selected
    itemsTable.addEventListener("change", (e) => {
      if (e.target.classList.contains("sales-product-select")) {
        const selectedOption = e.target.selectedOptions[0];
        const price = selectedOption?.dataset.price;
        const row = e.target.closest("tr");
        const unitPriceField = row.querySelector(".sales-unit-price");

        // if price is "" or nil, fallback to 0
        const parsedPrice = parseFloat(price);
        unitPriceField.value = isNaN(parsedPrice) ? 0 : parsedPrice.toFixed(2);

        recalcRowTotal(row);
        recalcOrderTotal();
      }
    });

    itemsTable.querySelectorAll(".sales-item-row").forEach(row => recalcRowTotal(row));
    recalcOrderTotal();
  }
});
